import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Review = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9941 12C20.9941 12.9805 20.2557 13.7885 19.3046 13.8984C18.4648 17.1029 15.549 19.4671 12.081 19.4671C9.54975 19.4671 7.31267 18.2076 5.96226 16.2811L6.78499 15.7125C7.95489 17.3783 9.8908 18.4671 12.081 18.4671C15.047 18.4671 17.5466 16.4704 18.3091 13.7479C17.6392 13.4509 17.1719 12.78 17.1719 12C17.1719 10.9445 18.0275 10.0888 19.083 10.0888C20.1385 10.0888 20.9941 10.9445 20.9941 12ZM17.4259 8.35804C16.2615 6.65247 14.302 5.5329 12.081 5.5329C9.12289 5.5329 6.62864 7.51899 5.85899 10.2304C6.55585 10.5156 7.04678 11.2004 7.04678 12C7.04678 13.0554 6.19113 13.9111 5.13563 13.9111C4.08014 13.9111 3.22449 13.0554 3.22449 12C3.22449 11.0397 3.93274 10.2448 4.85538 10.1092C5.69263 6.90079 8.61029 4.5329 12.081 4.5329C14.643 4.5329 16.9037 5.8232 18.2486 7.78941L17.4259 8.35804Z"
        fill={color}
      />
    </svg>
  )
})

export default Review
